import type { RouteLocationNormalized } from 'vue-router';

/**
 * Resolve the last-viewed dataset id before ResultPage mounts, so entering /dataset/result with a
 * stored lastResult lands on /dataset/result/:id in a single navigation. Redirecting from inside
 * the page (onBeforeMount) instead remounts it via RouterView's :key="route.path", which strands
 * PrimeVue TabList's 150ms updateInkBar timeout on the unmounted instance and throws
 * "Cannot read properties of null (reading 'style')".
 *
 * Wired into the `results` route as `beforeEnter` (see router/routes.ts). Kept here — owned by the
 * result module, unit-testable as a pure function — rather than inline in the global route table.
 */
export function resolveLastResultDataset(to: RouteLocationNormalized) {
  if (to.params.id) return true;
  try {
    const stored = localStorage.getItem('lastResult');
    const datasetId = stored ? JSON.parse(stored)?.dataset_id : undefined;
    if (datasetId) {
      return {
        name: 'results',
        params: { id: String(datasetId) },
        query: to.query,
      };
    }
  } catch {
    // malformed storage — fall through to the page's own dataset resolution
  }
  return true;
}
